import {
  Container,
  StyledCounter,
  TitleTextStyled,
} from './TitleWithCounter.styles';
interface Props {
  title: string;
  counter: number | string;
  'data-testid'?: string;
}
export const TitleWithCounter = ({ title, counter = 0, ...props }: Props) => {
  return (
    <Container>
      <TitleTextStyled data-testid={props['data-testid'] + '_title'}>
        {title}
      </TitleTextStyled>
      <StyledCounter data-testid={props['data-testid'] + '_counter'}>
        ({counter})
      </StyledCounter>
    </Container>
  );
};
